import styled from "styled-components";
import DesignConstants from "../../../../../../constants/DesignConstants";
import PhaseSixIcon from "../../../../../../basic/phaseSixIcon/PhaseSixIcon";
import { WordScoreBubbleWrapper } from "../../../../../../basic/wordScoreBubble/StyledComponents";

export const MobileWordCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${DesignConstants.COLORS.WHITE};
    border: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.LIGHTEST_GREY};
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    overflow: hidden;
`;

export const MobileWordCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${DesignConstants.SPACES.XS} ${DesignConstants.SPACES.S};
    border-bottom: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.LIGHTEST_GREY};

    ${WordScoreBubbleWrapper} {
        border: none;
        padding: 0;
    }
`;

export const MobileIconButton = styled.button`
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
    color: inherit;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

export const MobileWordCardDeleteIcon = styled(PhaseSixIcon)`
    font-size: ${DesignConstants.FONT_SIZES.XL};
`;
